import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

// core components
import PortalHeader from "../components/portalHeader.jsx";
// import Footer from "components/Footer/Footer.jsx";
import { usePortalStyles } from "../styles/portalStyles";
import { portalRoutes, routeMap } from "../routes/portalRoutes";
import {
  isLoggedIn,
  isMagicTokenLoggedIn,
  checkRestrictedTokenAndSendEmail,
} from "../utils/portalCookies";

const KTOKEN_LENGTH = 40;

// A wrapper for <Route> that redirects to the login page if not yet authenticated.
const AuthRequiredRoute = ({ children, ...rest }) => {
  const [tokenLoggedIn, setTokenLoggedIn] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);
  const [restrictedToken, setRestrictedToken] = useState(false);
  const [finishedLoginCheck, setFinishedLoginCheck] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const hasKtoken = queryParams.has("ktoken");
  const hasValidKtoken =
    queryParams.has("ktoken") &&
    queryParams.get("ktoken").length === KTOKEN_LENGTH;
  const hasInvalidKtoken =
    queryParams.has("ktoken") &&
    queryParams.get("ktoken").length !== KTOKEN_LENGTH;

  // Check token login async, will redirect if false (null indicates unknown)
  useEffect(async () => {
    if (hasKtoken) {
      let mtli = await isMagicTokenLoggedIn();
      setTokenLoggedIn(mtli);
    }
    if (!hasKtoken) {
      const tokenRestricted = await checkRestrictedTokenAndSendEmail();
      if (tokenRestricted) {
        setRestrictedToken(true);
      }
    }
    const isLoggedInValue = isLoggedIn();
    setLoggedIn(isLoggedInValue);
    setFinishedLoginCheck(true);
  }, []);

  let loginRedirect = true;

  if (tokenLoggedIn && !restrictedToken) {
    loginRedirect = false;
  }
  if (loggedIn && !restrictedToken) {
    loginRedirect = false;
  }

  let errorMessage = "";

  if (hasValidKtoken && !restrictedToken) {
    errorMessage = "Expired login link - check your email for a new link.";
  }
  if (hasInvalidKtoken && !restrictedToken) {
    errorMessage = "Invalid login link";
  }
  if (restrictedToken) {
    errorMessage = "Check your email for a login link.";
  }

  if (!finishedLoginCheck) {
    return <div></div>;
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        !loginRedirect ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: routeMap.login,
              state: { from: location, errorMessage: errorMessage },
            }}
          />
        )
      }
    />
  );
};

export default function PortalLayout(props) {
  const { ...rest } = props;
  const classes = usePortalStyles();

  return (
    <React.Fragment>
      <Switch>
        {portalRoutes.map((route, key) => {
          if (route.inactive) {
            return null;
          }
          if (route.redirect) {
            return <Redirect from={route.path} to={route.pathTo} key={key} />;
          }

          const componentProps = {
            ...(props || {}),
            ...(route.componentProps || {}),
          };

          // render route that is public and not behind login
          if (route.public) {
            return (
              <Route
                path={route.path}
                exact={route.exact || true}
                render={(props) => (
                  <React.Fragment>
                    <PortalHeader {...rest} />
                    <div
                      style={{ maxHeight: "100vh" }}
                      className={classes.mainContent}
                    >
                      <route.component {...componentProps} />
                    </div>
                  </React.Fragment>
                )}
                key={key}
              />
            );
          }

          // default route is behind password login
          return (
            <AuthRequiredRoute
              path={route.path}
              exact={route.exact || true}
              key={key}
            >
              <React.Fragment>
                <PortalHeader {...rest} loggedIn />
                <div
                  style={{ maxHeight: "100vh" }}
                  className={classes.mainContent}
                >
                  <route.component {...props} />
                </div>
              </React.Fragment>
            </AuthRequiredRoute>
          );
        })}
      </Switch>
    </React.Fragment>
  );
}
